var render = function render(_c,_vm){return _c('div',{staticClass:"fnempty"},[_c('img',{attrs:{"src":require("../assets/img_wsj.png"),"alt":""}}),_c('div',{staticClass:"fnempty-msg"},[_vm._v(_vm._s(_vm.props.message || '暂无信息'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }